import { UI_HeroCard } from 'ui/components/2-molecules/Card/HeroCard/HeroCard';
import { DynamicPlayer } from './DynamicPlayer';
import { SearchInput } from '2-feature/Search/SearchInput';

export const HeroCardSearch = ({ content, settings }: Content.HeroCardSearch) => {
	const { video } = content ?? {};
	const { layout } = settings?.properties ?? {};
	const searchInputLabelId = 'hero-search-heading';

	return (
		<UI_HeroCard
			{...content}
			layout={layout}
			link={undefined}
			player={video && <DynamicPlayer url={video.url} loop={true} />}
			searchInput={<SearchInput labelledById={searchInputLabelId} noMargin />}
			id={searchInputLabelId}
		/>
	);
};
